// extracted by mini-css-extract-plugin
export default {"PageContainer":"pageContainer_PageContainer__Syqw8","inner":"pageContainer_inner__kHn3q"};